export default __webpack_public_path__ + "static/media/8.b4940062.jpg";